/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import Transaction from 'entities/Transaction';

export default class Transactions extends Collection {
  initialize() {
    this.model = Transaction;
    this.comparator = (a, b) => b.getCreatedAt() - a.getCreatedAt();
  }

  parse(response: Object) {
    return response.map(transaction => Transaction.fromJSON(transaction));
  }

  static loadChargeTransactions() {
    return apiRequest('/payments/charges', 'GET').then(
      transactions => Transactions.fromJSON(transactions)
    );
  }

  static load() {
    return apiRequest('/payments/transactions', 'GET').then(
      transactions => Transactions.fromJSON(transactions)
    );
  }
}



// WEBPACK FOOTER //
// ./src/collections/Transactions.js